<template>
  <div>
    <b-button class="typo-butt-add mt-3 mr-1 but-add"  @click="handleCounter">
      <i class="fas fa fa-1x fa-plus mr-2"></i>
      {{$t("add_cu_button.text")}}
    </b-button>

    <!-- Aggiungi nuova centrale Modal-->
    <b-modal
      no-close-on-backdrop
      :hide-footer="footer_hide"
      ok-only
      ref="modal"
      id="modal-add-cu"
      :addCu="addCu"
      :title="$t('add_cu_modal.title')"
      :ok-title="$t('add_cu_modal.button_add_cu')"
      :cancel-title="$t('add_cu_modal.add_from_remote')"
      @ok="manualPressEnroll"
      cancel-variant="primary"
    >
      <b-form-group v-if="form_seen">
        <label for="label-cu-type">{{$t("add_cu_modal.label_cu_type")}}</label>
        <b-row>
        <b-col cols="9">
          <b-form-select v-model="cuSelected" class='mt-2' @change="setCuType">
            <option v-for="(selectOption, indexOpt) in this.cuTypeList" 
              :key="indexOpt"
              :value="selectOption"
            >
            {{ selectOption.order_code }} {{ selectOption.product_desc }} 
            </option>
          </b-form-select>
        </b-col>
        <b-col cols="3">
          <img class="img-fluid" style="height:50px" :src="this.cuSelected?this.pathDeviceImages+this.cuSelected.product_image:null">   
        </b-col>  
        </b-row>  
      </b-form-group>
      <b-row>
        <b-col cols="9">  
        <b-form-group v-if="form_seen">
          <label for="label-cu-serial">{{$t("add_cu_modal.label_cu_serial")}}</label>
          <span v-if="this.cuType=='logica' || this.cuType=='cablecom'" content=
              "<div style='width:150px'> Serial number example
              <img  class='img-fluid' src='img/qr_cent_nube_6.jpg'>
              </div>"
              v-tippy="{ placement : 'right',  arrow: true}">
                <i class="fa fa-1x fa-info-circle ml-2" style="color:#009DE0"></i>
          </span>
          <span v-else content=
          "<div style='width:150px'> Serial number example
            <img  class='img-fluid' src='img/qr_cent_nube_5.jpg'>
            </div>"
            v-tippy="{ placement : 'right',  arrow: true}">
            <i class="fa fa-1x fa-info-circle ml-2" style="color:#009DE0"></i>
      </span>
          <b-form-input
          v-model="cuSerial"
          type="text"
          size="6"
          :state="validation_cuSerial"
          id="placeholder-cu-serial6"
          
          ></b-form-input>
          <b-form-invalid-feedback
          :state="validation_cuSerial"
          v-if="this.cuType!='logicafm' && this.cuType!='sicuro' "
          >{{$t("add_cu_modal.validation_error_6")}}</b-form-invalid-feedback>
          <b-form-invalid-feedback
          :state="validation_cuSerial"
          v-if="this.cuType=='logicafm' || this.cuType=='sicuro'"
          >{{$t("add_cu_modal.validation_error_5")}}</b-form-invalid-feedback>
        </b-form-group>
       </b-col>
       <b-col cols="3">
       </b-col> 
      </b-row>
      <b-row v-if="countdown_seen" ref="countDown_row" :state="enroll_message_parse">
        <div class="card-body text-center">
          <label for="label-cu-serial">{{this.cuSelected.order_code!="21102"?$t("add_cu_modal.press_button_enroll"):$t("add_cu_modal.press_button_enroll_fm")}}</label>
          <div class="text-center">
            <span class="number h1">{{ countDown }}</span>
          </div>
          <div class="sk-spinner sk-spinner-pulse"></div>

        <!--- Button for remote press admin and some mail-->
        <b-button  v-if="this.$store.state.user.usertype=='admin' || this.$store.state.user.email=='aws@beghelli.it' || this.$store.state.user.email=='cloud@hostwave.co.uk' || this.$store.state.user.email=='wsparcie@beghelli-polska.pl'" variant="primary" @click="sendGetSwInfoForEnroll">{{$t('add_cu_modal.add_from_remote')}}</b-button>
        
        </div>
      </b-row>
      <b-row v-if="response_seen" :state="enroll_response">
        <b-col sm="12">
          <div class="text-center">
            <i class="fa fa-4x fa-check" style="color:green" aria-hidden="true"></i>
          </div>
          <div class="text-center mt-3 mb-3">{{enroll_response}}</div>
        </b-col>
      </b-row>
      <b-row v-if="error_seen" :state="enroll_error">
        <b-col sm="12">
          <div class="text-center">
            <i class="fa fa-4x fa-exclamation-triangle" style="color:orange" aria-hidden="true"></i>
          </div>
          <div class="text-center mt-3 mb-3">{{enroll_error}}</div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ManageClient",
  data() {
    return {
      cuType: "cablecom",
      cuSelected:"",
      addCu: false,
      cuSerial: "",
      countDown: "",
      countDown_init: 15,
      countdown_seen: false,
      form_seen: false,
      response_seen: false,
      error_seen: false,
      footer_hide: false,
      enroll_error: null,
      enroll_response: null,
      cuTypeList:[],
      pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,                 //pathDeviceImages for DEV : "https://d7e8bp38d6h8e.cloudfront.net/",
    };
  },
  computed: {
    ...mapState(['loading','commandResponse']),
   
    //validation serial cu
    validation_cuSerial() {
      if (this.addCu == true)
        if (this.cuType =="logicafm" || this.cuType =="sicuro")
        {
          return this.cuSerial.length == 5 && this.OnlyHexInString(this.cuSerial);
        }
        else
          return this.cuSerial.length == 6 && this.OnlyHexInString(this.cuSerial);
    },

    //parsing enroll message
    enroll_message_parse() {
      //Check if there's a response of enroll command
      console.log("response enroll frontend",this.$store.state.commandResponse);
      if (
        this.$store.state.commandResponse.pending != true &&
        (this.$store.state.commandResponse.command == "ENROLL" ||
          this.$store.state.commandResponse.command == "KEYPRESSED")
      ) {
        this.countdown_seen = false;
        if (this.$store.state.commandResponse.error == "") {
          if ((this.$store.state.commandResponse.response = "KEYPRESSED")) {
            this.$store.dispatch("enrollCuAck", {
              serial: this.cuSerial,
              type: this.cuType
            });
          }
          if ((this.$store.state.commandResponse.response = "ACKENROLL")) {
            this.enroll_response =
              this.$t("central_unit") +
              " " +
              this.cuSerial +
              " " +
              this.$t("add_cu_modal.enroll_ok");
            this.error_seen = false;
            this.response_seen = true;

            //save in db
            this.$store.dispatch("dbSaveCu", {
              serial: this.cuSerial,
              type: this.cuType,
              plant: this.$store.state.currentPlant.id
            });

            //define route path
            //let path_devices = "/plantcentralunits/" + this.$store.state.currentPlant.id;

            //send to device page
            setTimeout(() => {
              this.$store.dispatch('loadUnitsDetails', this.$store.state.currentPlant.id);
            }, 1500);

                  // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
          }
        } else {
          this.error_seen = true;
          if (this.$store.state.commandResponse.error == "ALREADY_ENROLLED") {
            this.enroll_error = this.$t("add_cu_modal.error_enrolled");
          } else if (
            this.$store.state.commandResponse.error == "TIMEOUT_KEYPRESSED"
          ) {
            console.log("Timeout pressed: ", this.cuSelected.order_code);
            this.cuSelected.order_code!="21102"?this.$t("add_cu_modal.error_timeout"):this.$t("add_cu_modal.error_timeout_fm")
          } else if (
            this.$store.state.commandResponse.error ==
            "ERROR_COMMAND_NOT_ENABLED") 
          {
            this.enroll_error = this.$t(
              "add_cu_modal.error_enrolled_not_enabled"
            );
          } else {
            this.enroll_error =
              this.$t("add_cu_modal.error_enrolled_not_enabled") +
              this.$store.state.commandResponse.error;
          }
        }
      } else {
        if (this.countDown == "0") {
          this.countdown_seen = false;
          this.error_seen = true;
          this.enroll_error = this.cuSelected.order_code!="21102"?this.$t("add_cu_modal.error_timeout"):this.$t("add_cu_modal.error_timeout_fm");
        }
      }
    }
  },

  watch: {
        loading(val,oldval) {
             if (val!=oldval)
             {
               this.cuTypeList=this.$store.state.allCuProductInfo;
               if(this.cuTypeList && !this.cuSelected)
                  this.cuSelected=this.cuTypeList[0];
               console.log("All cu list", this.cuTypeList);
               console.log("cu default",this.cuSelected);
             }
        },

        //command response watch to trigger remote press
        commandResponse(val, oldval) {
          
          console.log("remote press commandResponse ->", val);
            
          if (val.error == "") 
            {
              if (val.command == "GET SW INFO") 
              {
               console.log("REMOTE CU IS ON LINE");
               setTimeout(() => {
                  console.log("REMOTE 2) SEND KEYPRESS SIMULATION");
                  this.$store.dispatch("keypressSimulation", {
                      serial: this.cuSerial,
                      type: this.cuType
                  });
                }, 1500);
              }       
          }
        },
  },

  methods: 
  {

    //----------------------------------------------------------
    //----- REMOTE PRESS ENROLL SOLO PER ADMIN -----------------   
    //----------------------------------------------------------
    //Send get sw info to check if control unit is online
      sendGetSwInfoForEnroll() {
        if (this.OnlyHexInString(this.cuSerial) && this.cuSerial.length == 6 || this.cuSerial.length == 5) {

          this.$store.dispatch('sendCablecomCommand', {cu_command: 'getSwInfo' , cu_type: this.cuType, cu_id: this.cuSerial});

          this.countDown = this.countDown_init;
          this.countDownTimer();
          this.countdown_seen = true;
          this.footer_hide = true;
          this.form_seen = false;
        } 
        else {
          return;
        }
      },


    //---------------------------------------------------------------------------------
    //----- GESTIONE MANUALE ENROLL CON PRESS DUE PULSANTI FISICI DELLA CENTRALE ------
    //---------------------------------------------------------------------------------
    manualPressEnroll(bvModalEvt) {
      
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.error_seen = false;
      const plant = this.$store.state.currentPlant;
      
      if (plant.plant_type == 'basic' || this.$store.getters.isProExpired) 
       {
         //Verifico se si cerca di inserire un impianto multisistema senza avere la funzione Pro         
          const numCent = plant.controlunits.length || 0;
          if (numCent > 0) 
          {  
            var multisystem_alert=false;
            plant.controlunits.forEach(element => {
              let type = element.cutype;
              if (type != this.cuType) {
                multisystem_alert=true;
                console.log("Errore: creazione di un impianto multisitema senza PRO code");
                this.error_seen = true;
                this.footer_hide = true;
                this.form_seen = false;
                this.enroll_error = this.$t("settings.errProMultisystem")+ "\n" + this.$t("settings.claimPro");
              }
              else
              {
                this.addCu = true;
                // Trigger add Cu
                this.addCentralUnit();
              }
            });
          }
          else
          {
            this.addCu = true;
            // Trigger add Cu
            this.addCentralUnit();
          }
       }
       else
       {
        this.addCu = true;
        // Trigger add Cu
        this.addCentralUnit();
       }
    },

    OnlyHexInString(hex) {
      return !isNaN(Number("0x" + hex));
    },

    setCuType(e)
    {
            
      if (e.order_code=="20151")
        this.cuType="cablecom";
      else if (e.order_code=="12100C")
        this.cuType="logica";
      else if (e.order_code.startsWith("2927001"))
        this.cuType="sicuro";  
      else
        this.cuType="logicafm";
      
      console.log("CU Type: ", this.cuType);
          
    },

    addCentralUnit() {
      if (this.OnlyHexInString(this.cuSerial) 
            && (this.cuType!="logicafm" && this.cuType!="sicuro" && this.cuSerial.length == 6) 
            || ((this.cuType=="logicafm" || this.cuType=="sicuro") && this.cuSerial.length == 5))  {
        this.$store.dispatch("enrollCu", {
          serial: this.cuSerial,
          type: this.cuType
        });
        this.countDown = this.countDown_init;
        this.countDownTimer();
        this.countdown_seen = true;
        this.footer_hide = true;
        this.form_seen = false;
      } else {
        return;
      }
    },

    handleCounter(bvModalEvt) {
      
      //Load all the cu info
      this.$store.dispatch('loadAllCuProductInfo');      
      console.log("Cu type on open: ", this.cuType);
      
      const plant = this.$store.state.currentPlant;
      console.log("currentPlant", plant);

      const numCent = plant.controlunits.length || 0;

      //check if plant type=Basic or plant Pro is expired
      if (plant.plant_type == 'basic' || this.$store.getters.isProExpired) 
      {
     
        //check number of control units for type
        if(numCent>0)
        {    
          //check if the number of cu exceed the basic limit
          var msgExceedBasic= this.checkListCuInPlant(plant.controlunits);

          if(msgExceedBasic!="")
          {
            this.$bvModal.msgBoxConfirm(plant.plant_type == 'basic'?msgExceedBasic:this.$t("CU_LIMIT_PRO_EXPIRED"), 
            {
              title: this.$t('CU_LIMIT_TITLE'),
              okVariant: 'warning',
              okTitle: this.$t('settings.activePro'),
              cancelTitle:this.$t('close'),
              centered: true
            }).then((value) => 
            {
              if (value == true) 
              {
                this.$router.push({
                  name: "GeneraliImpianto",
                  params: { plantId: this.$store.state.currentPlant.id }
                });
              }
            });
            return;
          }
        }

      }       

      this.$root.$emit("bv::show::modal",'modal-add-cu');

      this.countdown_seen = false;
      this.response_seen = false;
      this.error_seen = false;
      this.footer_hide = false;
      this.form_seen = true;
      this.countDownTimer();
      this.countDown = 0;
    },

    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },

    checkListCuInPlant(plantCu)
    {
          var numCuCablecom=0;
          var numCuLogica=0;
          var numCuLogicaFM=0;
          var numCuSicuro=0;
          var numCuGateway=0;

          var retMsg="";
          
          plantCu.forEach((cent) => 
          { 
            if(cent.cutype == "cablecom")
              numCuCablecom++;  
            if(cent.cutype == "logica")
              numCuLogica++;
            if(cent.cutype == "logicafm")
              numCuLogicaFM++;
            if(cent.cutype == "sicuro")
              numCuSicuro++;
            if(cent.cutype == "blegateway")
              numCuGateway++;    
          });
         
          console.log("centrali cablecom: " + numCuCablecom);
          console.log("centrali logica: " + numCuLogica);
          console.log("centrali logicaFM: " + numCuLogicaFM);
          console.log("centrali sicuro: "+ numCuSicuro);
          console.log("centrali blegateway: " + numCuGateway);

          console.log("limit basic da lambda main: ", this.$store.state.appConfig);

          if (numCuCablecom >= this.$store.state.appConfig.maxCablecomUnits || 
            numCuLogica >= this.$store.state.appConfig.maxLogicaUnits || 
            numCuLogicaFM >= this.$store.state.appConfig.maxLogicaFmUnits || 
            numCuSicuro  >= this.$store.state.appConfig.maxSicuroUnits || 
            numCuGateway >= this.$store.state.appConfig.maxGatewayUnits)
            {  
          
            retMsg= (numCuCablecom >= this.$store.state.appConfig.maxCablecomUnits)? this.$t("CU_LIMIT_EXCEEDED")  + " " + this.$store.state.appConfig.maxCablecomUnits + " " + this.$t("central_units").toLowerCase() + " Cablecom":
                    (numCuLogica >= this.$store.state.appConfig.maxLogicaUnits)? this.$t("CU_LIMIT_EXCEEDED")  + " " + this.$store.state.appConfig.maxLogicaUnits + " " + this.$t("central_units").toLowerCase() + " Logica":
                    (numCuLogicaFM >= this.$store.state.appConfig.maxLogicaFmUnits)? this.$t("CU_LIMIT_EXCEEDED")  + " " + this.$store.state.appConfig.maxLogicaFmUnits + " " + this.$t("central_units").toLowerCase() + " LogicaFM":
                    (numCuSicuro >= this.$store.state.appConfig.maxSicuroUnits)? this.$t("CU_LIMIT_EXCEEDED")  + " " + this.$store.state.appConfig.maxSicuroUnits + " " + this.$t("central_units").toLowerCase() + " Sicuro":
                    (numCuGateway >= this.$store.state.appConfig.maxGatewayUnits)? this.$t("CU_LIMIT_EXCEEDED")  + " " + this.$store.state.appConfig.maxGatewayUnits + " Gateway":""
           }
       
        return retMsg;   

    }
  
  }

};
</script>
